import { ComponentProps } from 'react';

import Text from '../Text/Text';

type ParagraphProps = Omit<ComponentProps<typeof Text>, 'tag'>;

const Paragraph = (props: ParagraphProps) => {
    return <Text tag="p" {...props} />;
};

export default Paragraph;
